import styled from "styled-components";
import theme from "../../../../theme";
import { Col } from "antd";

export const FirstScallToFullScaleSection = styled.div`
  margin: 0 0 96px;

  @media (max-width: 426px) {
    margin: 0 0 72px;
  }
`;

export const LogoContainer = styled.div`
  margin-top: 72px;
  div {
    font-family: "Inter", sans-serif;
    font-style: normal;
    font-size: 18px;
    line-height: 28px;
    color: #000000;
  }

  span {
    font-weight: 400;
    color: #00afaa;
  }
`;

export const StyledCol = styled(Col)`
  text-align: center;

  @media (max-width: 992px) {
    margin-bottom: 20px;
  }
`;

export const SwiperDiv = styled.div`
  .swiper {
    width: 100%;
    height: 100%;
    padding: 40px 0;
    padding-left: calc((100vw - 1220px) / 2);
    @media (max-width: 1220px) {
      padding-left: 70px;
    }
    @media (max-width: 790px) {
      padding-left: 50px;
    }
    @media (max-width: 426px) {
      padding-left: 20px;
    }
  }

  .swiper-wrapper .swiper-slide:last-child {
    margin-right: 30px;
  }

  .swiper-slide {
    max-width: 380px;
    /* min-height: 330px; */
    text-align: center;
    font-size: 18px;
    background: #00afaa;
    color: #fff;
    padding: 30px;
    border-radius: 10px;

    ul {
      list-style-type: none;
    }
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .my-custom-pagination-div {
    text-align: center;
    margin-top: 60px;
    padding-right: calc((100vw - 1220px) / 2);
    @media (max-width: 1220px) {
      padding-right: 70px;
    }
    @media (max-width: 790px) {
      padding-right: 50px;
      margin-top: 30px;
    }
    @media (max-width: 426px) {
      padding-right: 20px;
    }
  }

  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: transparent;
    border: 1px solid ${theme.black};
    opacity: 1 !important;
  }
  .swiper-pagination-bullet-active {
    background: ${theme.black};
  }
`;

export const SlideTitle = styled.h2`
  font-size: 28px;
  font-weight: 500;
  line-height: normal;
`;

export const SlideContent = styled.div`
  font-size: 18px;
  line-height: normal;
  margin-bottom: 0;
`;
